import common from "@charmdeer/common";
import { defineStore } from "pinia";

import { getDeployment, getHlDeployment } from "@/api/biz/common";
import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { store } from "@/store";

export const useDeploymentStore = defineStore({
  id: "sys-deployment",
  state: () => ({
    deploymentLoaded: false,
    toggles: null,
    terms: {},
    clients: null,
    layout: {
      hotelList: "twoColumn", // 'oneColumn' | 'twoColumn'
      hotelListFilter: "horizontal", // 'vertical' | 'horizontal'
      hotelRoomList: "comfortable" // 'compact' | 'comfortable'
    }
  }),
  actions: {
    async getToggle() {
      const res = await getDeployment();
      const yChannelStore = useYChannelStoreHook();
      let hlRes;
      if (
        ["dbs", "hlgp", "dc", "hoteluxjp", "hotelux"].includes(
          yChannelStore.channel
        )
      ) {
        hlRes = await getHlDeployment();
      }
      if (res?.success || hlRes?.success) {
        const resToggles = Array.isArray(res?.toggles) ? res.toggles : [];
        const hlToggles = Array.isArray(hlRes?.toggles) ? hlRes.toggles : [];
        this.toggles = hlRes?.toggles
          ? [...resToggles, ...hlToggles]
          : resToggles;
        this.deploymentLoaded = true;
        this.terms = res?.strategy?.terms;
        this.clients = res?.strategy?.clients;
        common.runtime.toggle.reset(this.toggles);
        common.supplier.setDefinitions(res.supplierDefinitions?.definitions);

        const backendLayoutConfig = res?.strategy?.clients?.web?.layout;
        const isToggleActive = this.isActive(
          "Y_WEB_HOTEL_LAYOUT_CUSTOMIZATION"
        );
        if (backendLayoutConfig && isToggleActive) {
          this.layout = { ...this.layout, ...backendLayoutConfig };
        }
      }
    },
    isActive(toggle) {
      const yChannelStore = useYChannelStoreHook();
      return common.runtime.toggle.isActive(toggle, yChannelStore.channel);
    }
  }
});

export function useDeploymentStoreHook() {
  return useDeploymentStore(store);
}
